import React from "react";

import "./footer.css";
function Footer() {
  return (
    <div className="Footer">
      Copyrights © {new Date().getFullYear()}. All Right Reserved.
    </div>
  );
}

export default Footer;
